var map = {
	"../../pages/password/password.module.ngfactory": [
		"./src/app/pages/password/password.module.ngfactory.js",
		"pages-password-password-module-ngfactory"
	],
	"../../pages/student/student.module.ngfactory": [
		"./src/app/pages/student/student.module.ngfactory.js",
		"pages-student-student-module-ngfactory"
	],
	"../../pages/teacher/teacher.module.ngfactory": [
		"./src/app/pages/teacher/teacher.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"default~pages-teacher-teacher-module-ngfactory~teacher-pagela-teacher-pagela-module-ngfactory~teache~f5b0d7bf",
		"default~pages-teacher-teacher-module-ngfactory~teacher-pagela-teacher-pagela-module-ngfactory",
		"common",
		"pages-teacher-teacher-module-ngfactory"
	],
	"./layouts/auth-layout/auth-layout.module.ngfactory": [
		"./src/app/layouts/auth-layout/auth-layout.module.ngfactory.js",
		"layouts-auth-layout-auth-layout-module-ngfactory"
	],
	"./layouts/complete-register-layout/complete-register-layout.module.ngfactory": [
		"./src/app/layouts/complete-register-layout/complete-register-layout.module.ngfactory.js",
		"common",
		"layouts-complete-register-layout-complete-register-layout-module-ngfactory"
	],
	"./layouts/leveling-layout/leveling-layout.module.ngfactory": [
		"./src/app/layouts/leveling-layout/leveling-layout.module.ngfactory.js",
		"layouts-leveling-layout-leveling-layout-module-ngfactory"
	],
	"./layouts/register-layout/register-layout.module.ngfactory": [
		"./src/app/layouts/register-layout/register-layout.module.ngfactory.js",
		"layouts-register-layout-register-layout-module-ngfactory"
	],
	"./layouts/site-layout/site-layout.module.ngfactory": [
		"./src/app/layouts/site-layout/site-layout.module.ngfactory.js",
		"layouts-site-layout-site-layout-module-ngfactory"
	],
	"./layouts/student-layout/student-layout.module.ngfactory": [
		"./src/app/layouts/student-layout/student-layout.module.ngfactory.js",
		"layouts-student-layout-student-layout-module-ngfactory"
	],
	"./layouts/teacher-layout/teacher-layout.module.ngfactory": [
		"./src/app/layouts/teacher-layout/teacher-layout.module.ngfactory.js",
		"layouts-teacher-layout-teacher-layout-module-ngfactory"
	],
	"./student-dashboard/student-dashboard.module.ngfactory": [
		"./src/app/pages/student/student-dashboard/student-dashboard.module.ngfactory.js",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-profile-student-profile-module-~36fdb18f",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-finance-student-finance-module-~95ae65be",
		"default~student-dashboard-student-dashboard-module-ngfactory~teacher-pagela-teacher-pagela-module-ng~acd02e29",
		"common",
		"student-dashboard-student-dashboard-module-ngfactory"
	],
	"./student-enrollment/student-enrollment.module.ngfactory": [
		"./src/app/pages/student/student-enrollment/student-enrollment.module.ngfactory.js",
		"student-enrollment-student-enrollment-module-ngfactory"
	],
	"./student-finance/student-finance.module.ngfactory": [
		"./src/app/pages/student/student-finance/student-finance.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-finance-student-finance-module-~95ae65be",
		"common",
		"student-finance-student-finance-module-ngfactory"
	],
	"./student-history/student-history.module.ngfactory": [
		"./src/app/pages/student/student-history/student-history.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"common",
		"student-history-student-history-module-ngfactory"
	],
	"./student-leveling/student-leveling.module.ngfactory": [
		"./src/app/pages/student/student-leveling/student-leveling.module.ngfactory.js",
		"default~student-leveling-student-leveling-module-ngfactory~teacher-scheduler-teacher-scheduler-modul~1947067b",
		"common",
		"student-leveling-student-leveling-module-ngfactory"
	],
	"./student-order/student-order.module.ngfactory": [
		"./src/app/pages/student/student-order/student-order.module.ngfactory.js",
		"common",
		"student-order-student-order-module-ngfactory"
	],
	"./student-payment/student-payment.module.ngfactory": [
		"./src/app/pages/student/student-payment/student-payment.module.ngfactory.js",
		"common",
		"student-payment-student-payment-module-ngfactory"
	],
	"./student-profile/student-profile.module.ngfactory": [
		"./src/app/pages/student/student-profile/student-profile.module.ngfactory.js",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-profile-student-profile-module-~36fdb18f",
		"common",
		"student-profile-student-profile-module-ngfactory"
	],
	"./student-shopping-cart/student-shopping-cart.module.ngfactory": [
		"./src/app/pages/student/student-shopping-cart/student-shopping-cart.module.ngfactory.js",
		"common",
		"student-shopping-cart-student-shopping-cart-module-ngfactory"
	],
	"./student-talk-teacher/student-talk-teacher.module.ngfactory": [
		"./src/app/pages/student/student-talk-teacher/student-talk-teacher.module.ngfactory.js",
		"student-talk-teacher-student-talk-teacher-module-ngfactory"
	],
	"./teacher-consulta-pagela/teacher-consulta-pagela.module.ngfactory": [
		"./src/app/pages/teacher/teacher-consulta-pagela/teacher-consulta-pagela.module.ngfactory.js",
		"common",
		"teacher-consulta-pagela-teacher-consulta-pagela-module-ngfactory"
	],
	"./teacher-dashboard/teacher-dashboard.module.ngfactory": [
		"./src/app/pages/teacher/teacher-dashboard/teacher-dashboard.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-profile-student-profile-module-~36fdb18f",
		"common",
		"teacher-dashboard-teacher-dashboard-module-ngfactory"
	],
	"./teacher-holerite/teacher-holerite.module.ngfactory": [
		"./src/app/pages/teacher/teacher-holerite/teacher-holerite.module.ngfactory.js",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-profile-student-profile-module-~36fdb18f",
		"default~teacher-holerite-teacher-holerite-module-ngfactory~teacher-scheduler-leveling-students-teach~e4460ede",
		"common",
		"teacher-holerite-teacher-holerite-module-ngfactory"
	],
	"./teacher-pagela/teacher-pagela.module.ngfactory": [
		"./src/app/pages/teacher/teacher-pagela/teacher-pagela.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"default~student-dashboard-student-dashboard-module-ngfactory~student-profile-student-profile-module-~36fdb18f",
		"default~teacher-pagela-teacher-pagela-module-ngfactory~teacher-scheduler-leveling-calendar-teacher-s~4631d7f9",
		"default~pages-teacher-teacher-module-ngfactory~teacher-pagela-teacher-pagela-module-ngfactory~teache~f5b0d7bf",
		"default~teacher-pagela-teacher-pagela-module-ngfactory~teacher-scheduler-leveling-students-teacher-s~28e48a97",
		"default~pages-teacher-teacher-module-ngfactory~teacher-pagela-teacher-pagela-module-ngfactory",
		"default~student-dashboard-student-dashboard-module-ngfactory~teacher-pagela-teacher-pagela-module-ng~acd02e29",
		"common",
		"teacher-pagela-teacher-pagela-module-ngfactory"
	],
	"./teacher-scheduler-leveling-calendar/teacher-scheduler-leveling-calendar.module.ngfactory": [
		"./src/app/pages/teacher/teacher-scheduler/teacher-scheduler-leveling/teacher-scheduler-leveling-calendar/teacher-scheduler-leveling-calendar.module.ngfactory.js",
		"default~teacher-pagela-teacher-pagela-module-ngfactory~teacher-scheduler-leveling-calendar-teacher-s~4631d7f9",
		"common",
		"teacher-scheduler-leveling-calendar-teacher-scheduler-leveling-calendar-module-ngfactory"
	],
	"./teacher-scheduler-leveling-students/teacher-scheduler-leveling-students.module.ngfactory": [
		"./src/app/pages/teacher/teacher-scheduler/teacher-scheduler-leveling/teacher-scheduler-leveling-students/teacher-scheduler-leveling-students.module.ngfactory.js",
		"default~teacher-holerite-teacher-holerite-module-ngfactory~teacher-scheduler-leveling-students-teach~e4460ede",
		"default~teacher-pagela-teacher-pagela-module-ngfactory~teacher-scheduler-leveling-students-teacher-s~28e48a97",
		"common",
		"teacher-scheduler-leveling-students-teacher-scheduler-leveling-students-module-ngfactory"
	],
	"./teacher-scheduler-leveling/teacher-scheduler-leveling.module.ngfactory": [
		"./src/app/pages/teacher/teacher-scheduler/teacher-scheduler-leveling/teacher-scheduler-leveling.module.ngfactory.js",
		"common",
		"teacher-scheduler-leveling-teacher-scheduler-leveling-module-ngfactory"
	],
	"./teacher-scheduler/teacher-scheduler.module.ngfactory": [
		"./src/app/pages/teacher/teacher-scheduler/teacher-scheduler.module.ngfactory.js",
		"default~pages-teacher-teacher-module-ngfactory~student-finance-student-finance-module-ngfactory~stud~6b4c4726",
		"default~pages-teacher-teacher-module-ngfactory~teacher-pagela-teacher-pagela-module-ngfactory~teache~f5b0d7bf",
		"default~student-leveling-student-leveling-module-ngfactory~teacher-scheduler-teacher-scheduler-modul~1947067b",
		"common",
		"teacher-scheduler-teacher-scheduler-module-ngfactory"
	],
	"./teacher-search-student/teacher-search-student.module.ngfactory": [
		"./src/app/pages/teacher/teacher-search-student/teacher-search-student.module.ngfactory.js",
		"default~teacher-pagela-teacher-pagela-module-ngfactory~teacher-scheduler-leveling-calendar-teacher-s~4631d7f9",
		"common",
		"teacher-search-student-teacher-search-student-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;